import Enums from "../../enums/enums";
const state = {
  notificationIsConnect: false,
  notificationReadyToUse: false,
  notificationIsAuthenticated: false,
  notificationList: [],
  notificationCount: 0,
  notificationListLoadingStatus: Enums.LoadingStatusType.None,
  notificationCountLoadingStatus: Enums.LoadingStatusType.None,
  unSeenNotificationList: [],
  isSeenNotificationList: [],
  transactionTypeListForMap: new Map(),
  journalViewDetailListForMap: new Map(),
  paymentTransferViewDetailListForMap: new Map(),
  chequeViewDetailListForMap: new Map(),
  productCodeListForMap: new Map(),
  assetTemplateCodeListForMap: new Map(),
  bankAccountIdListForMap: new Map(),
};

const getters = {
  GetNotificationIsConnect: (state) => {
    return state.notificationIsConnect;
  },
  GetNotificationReadyToUse: (state) => {
    return state.notificationReadyToUse;
  },
  GetNotificationList: (state) => {
    return state.notificationList;
  },
  GetUnSeenNotificationList: (state) => {
    return state.unSeenNotificationList;
  },
  GetIsSeenNotificationList: (state) => {
    return state.isSeenNotificationList;
  },
  GetNotificationCount: (state) => {
    return state.notificationCount;
  },
  GetNotificationListLoadingStatus: (state) => {
    return state.notificationListLoadingStatus;
  },
  GetNotificationCountLoadingStatus: (state) => {
    return state.notificationCountLoadingStatus;
  },
  GetNotificationIsAuthenticated: (state) => {
    return state.notificationIsAuthenticated;
  },
  GetTransactionTypeListForMap: (state) => {
    return state.transactionTypeListForMap;
  },
  GetJournalViewDetailListForMap: (state) => {
    return state.journalViewDetailListForMap;
  },
  GetPaymentTransferViewDetailListForMap: (state) => {
    return state.paymentTransferViewDetailListForMap;
  },
  GetChequeViewDetailListForMap: (state) => {
    return state.chequeViewDetailListForMap;
  },
  GetProductCodeListForMap: (state) => {
    return state.productCodeListForMap;
  },
  GetAssetTemplateCodeListForMap: (state) => {
    return state.assetTemplateCodeListForMap;
  },
  GetBankAccountListForMap: (state) => {
    return state.bankAccountIdListForMap;
  },
};

export { getters, state };
